var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect, _rect2, _rect3, _rect4, _path9, _path10, _path11, _rect5, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTapIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "f9bde750-e2b9-47cd-b9f0-a040c558db1f",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 79.97 93.21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a18a3ff8-2ad7-4cb6-9d8f-d86fee9ab7df{fill:#fdbb41;}.a18a3ff8-2ad7-4cb6-9d8f-d86fee9ab7df,.acd018ee-2296-4258-b5bd-7fbfa49fb18c,.ec4425e8-b645-484d-948d-5bf103ff853f{fill-rule:evenodd;}.a361a10f-0460-4ece-895d-6a2ca126e7d6,.ec4425e8-b645-484d-948d-5bf103ff853f{fill:#2f2c3d;}.a480a213-ece1-4f19-9d4a-76808a5f2411,.acd018ee-2296-4258-b5bd-7fbfa49fb18c{fill:#f78f2e;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tap-icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a18a3ff8-2ad7-4cb6-9d8f-d86fee9ab7df",
    d: "M68.57,95.34A2.18,2.18,0,0,1,66.24,93V91a.87.87,0,0,0-.85-.85H34.58a.87.87,0,0,0-.85.85v1.7a2.84,2.84,0,0,1-.6,1.93,2.3,2.3,0,0,1-1.83.75H29.72a3.13,3.13,0,0,1-3.12-3.12V73.87H73.37V92.35a3,3,0,0,1-3,3H68.57Z",
    transform: "translate(-10.02 -3.4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a361a10f-0460-4ece-895d-6a2ca126e7d6",
    d: "M72.07,75.13V92.32a1.75,1.75,0,0,1-1.73,1.73h-1.8c-.76,0-1-.38-1-1.1V91a2.14,2.14,0,0,0-2.14-2.14H34.55A2.14,2.14,0,0,0,32.4,91v1.7c0,1-.37,1.39-1.13,1.39H29.69a1.83,1.83,0,0,1-1.83-1.83V75.16H72.07m2.59-2.61H25.31V92.19a4.42,4.42,0,0,0,4.41,4.41H31.3a3.65,3.65,0,0,0,2.81-1.19A4.15,4.15,0,0,0,35,92.63V91.37H65v1.55a3.45,3.45,0,0,0,3.62,3.68h1.8a4.33,4.33,0,0,0,4.32-4.31V72.55Z",
    transform: "translate(-10.02 -3.4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "acd018ee-2296-4258-b5bd-7fbfa49fb18c",
    d: "M27.9,75.13H72.07v3a39.14,39.14,0,0,1-44.21,0v-3Z",
    transform: "translate(-10.02 -3.4)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M50,3.4a40,40,0,1,1-40,40,40,40,0,0,1,40-40",
    transform: "translate(-10.02 -3.4)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "acd018ee-2296-4258-b5bd-7fbfa49fb18c",
    d: "M50,6.23A37.15,37.15,0,1,1,12.85,43.38,37.15,37.15,0,0,1,50,6.23",
    transform: "translate(-10.02 -3.4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "a18a3ff8-2ad7-4cb6-9d8f-d86fee9ab7df",
    d: "M87.11,44.07a37.14,37.14,0,0,1-74.26,0,37.14,37.14,0,0,1,74.26,0",
    transform: "translate(-10.02 -3.4)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "acd018ee-2296-4258-b5bd-7fbfa49fb18c",
    d: "M50,11.25A32.13,32.13,0,1,1,17.87,43.38,32.12,32.12,0,0,1,50,11.25",
    transform: "translate(-10.02 -3.4)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "a18a3ff8-2ad7-4cb6-9d8f-d86fee9ab7df",
    d: "M82.07,44.77a32.13,32.13,0,0,1-64.2,0,32.13,32.13,0,0,1,64.2,0",
    transform: "translate(-10.02 -3.4)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a480a213-ece1-4f19-9d4a-76808a5f2411",
    x: 19.49,
    y: 14.35,
    width: 0.95,
    height: 51.02
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "a480a213-ece1-4f19-9d4a-76808a5f2411",
    x: 32.89,
    y: 7.98,
    width: 0.95,
    height: 63.76
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "a480a213-ece1-4f19-9d4a-76808a5f2411",
    x: 57.7,
    y: 14.35,
    width: 0.95,
    height: 51.02
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "a480a213-ece1-4f19-9d4a-76808a5f2411",
    x: 44.3,
    y: 7.98,
    width: 0.95,
    height: 63.76
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M28.21,65.83V20.93a31.3,31.3,0,0,0,0,44.9m13.47,7.69V13.2a31.24,31.24,0,0,0-12.14,6.5V67A30.61,30.61,0,0,0,41.68,73.52Zm13.43.7V12.51A29.86,29.86,0,0,0,50,12.1a31.89,31.89,0,0,0-7,.79v61a32.5,32.5,0,0,0,7,.79A28,28,0,0,0,55.11,74.22Zm13.43-5.68V18.22A31.43,31.43,0,0,0,56.4,12.76V74A31.23,31.23,0,0,0,68.54,68.54Zm1.33-49.32V67.53a31.27,31.27,0,0,0,0-48.31ZM50,9.86A33.52,33.52,0,1,1,16.48,43.38,33.52,33.52,0,0,1,50,9.86Z",
    transform: "translate(-10.02 -3.4)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M79.67,58.92a33.53,33.53,0,0,1-59.41,0,32,32,0,0,1-2.42-12.29,32.46,32.46,0,0,1,1.57-10,31.8,31.8,0,0,0-.72,6.72,31.3,31.3,0,0,0,9.49,22.45V23c.41-.38.85-.76,1.29-1.14V67a31.1,31.1,0,0,0,12.14,6.49V15.6c.44-.13.85-.22,1.3-.32V73.87a32.5,32.5,0,0,0,7,.79,34.21,34.21,0,0,0,5.11-.41V14.9l1.29.23V74a31.07,31.07,0,0,0,12.14-5.45V20.39c.44.32.88.63,1.29,1V67.53A31.19,31.19,0,0,0,81.19,43.38a31.8,31.8,0,0,0-.73-6.72,32.61,32.61,0,0,1,1.58,10,30.2,30.2,0,0,1-2.37,12.29",
    transform: "translate(-10.02 -3.4)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M49.65,54.23a1.55,1.55,0,1,1-1.54,1.54,1.55,1.55,0,0,1,1.54-1.54",
    transform: "translate(-10.02 -3.4)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "a361a10f-0460-4ece-895d-6a2ca126e7d6",
    x: 38.75,
    y: 53.48,
    width: 1.8,
    height: 2.87
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M49.72,60.5c2.08,0,3.75,1.36,3.75,3s-1.67,3-3.75,3S46,65.14,46,63.5s1.68-3,3.76-3",
    transform: "translate(-10.02 -3.4)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M51.51,63.78l.41,8.1c0,.26-.22.35-.44.44a4.18,4.18,0,0,1-3.59,0c-.22-.09-.44-.18-.44-.44l.44-8.1a.44.44,0,0,1,.41-.28h2.77a.45.45,0,0,1,.44.28",
    transform: "translate(-10.02 -3.4)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M44,55.27v1.64a.22.22,0,0,0,.22.22L49,56.59a.21.21,0,0,0,.22-.22v-.44c0-.13-.09-.19-.22-.22l-4.76-.66a.21.21,0,0,0-.22.22",
    transform: "translate(-10.02 -3.4)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M55.3,55.27v1.64a.22.22,0,0,1-.22.22l-4.76-.54a.22.22,0,0,1-.23-.22v-.44c0-.13.1-.19.23-.22l4.76-.66a.24.24,0,0,1,.22.22",
    transform: "translate(-10.02 -3.4)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "ec4425e8-b645-484d-948d-5bf103ff853f",
    d: "M48.45,59.4h2.4a.21.21,0,0,1,.22.22v1.54a.21.21,0,0,1-.22.22h-2.4a.22.22,0,0,1-.22-.22V59.62a.22.22,0,0,1,.22-.22",
    transform: "translate(-10.02 -3.4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTapIcon);
export default __webpack_public_path__ + "static/media/tap-icon.7ca83286b3bcb8ffd6fa78d279e2c173.svg";
export { ForwardRef as ReactComponent };